/**
 * Created by h3 on 2018-01-25.
 */

import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Expo, Linear, TimelineLite, TweenLite} from "gsap";
import {TeslaGameAssets} from "../../../TeslaGameAssets";
import {TeslaGameConfig} from "../../../TeslaGameConfig";
import {BitmapTextStyleData, TeslaTextStyles} from "../../../../config/TeslaTextStyles";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class TeslaWinAmountDisplay extends BaseView {

    private _layer: ScalableLayer;
    private _container: PIXI.Container;
    private _textContainer: PIXI.Container;
    private _particleSprite: PIXI.Sprite;
    private _winNumbersText: PIXI.BitmapText;
    private _currentWin: number = 0;
    private _individualWinTextContainer: PIXI.Container;

    constructor(layer: ScalableLayer) {
        super();
        this._layer = layer;
    }

    protected initAnimations(): void {
        this._individualWinTextContainer = new PIXI.Container();
        this._individualWinTextContainer.position.set(0, 0);
        this._individualWinTextContainer.name = "individualTextConTainer";
        this._layer.addChild(this._individualWinTextContainer);

        this._container = new PIXI.Container();
        this._layer.addChild(this._container);

        this._textContainer = new PIXI.Container();
        this._layer.addChild(this._textContainer);


        this.createParticleWinEffect();
        this.createTexts();
    }


    protected onResize(resizeData: IResizeData): void {

        this._container.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.4);

        if (UserAgent.isMobile) {
            this._container.position.set(TeslaGameConfig.instance.GAME_WIDTH * 0.5, TeslaGameConfig.instance.GAME_HEIGHT * 0.4);

        }


    }

    private createParticleWinEffect() {
        this._particleSprite = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INITIAL_WIN_PARTICLES_BIG)[0]);
        this._particleSprite.blendMode = PIXI.BLEND_MODES.ADD;
        this._particleSprite.scale.set(1, 1);
        this._particleSprite.anchor.set(0.5, 0.6);
        this._particleSprite.alpha = 0;
        this._container.addChild(this._particleSprite);

    }

    private getParticleAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        this._particleSprite.position.set(0, 0);

        tl.add([
            new TweenLite(this._particleSprite, 0.2, {alpha: 1,}),
            new TweenLite(this._particleSprite.scale, 1, {x: 1, y: 1, ease: Expo.easeOut}),
            new TweenLite(this._particleSprite.position, 3, {
                y: "+=340",
                ease: Expo.easeIn
            })
        ]);
        tl.add([
            new TweenLite(this._particleSprite, 1.5, {alpha: 0, ease: Expo.easeOut})
        ], "-=1.5");
        tl.add([
            () => this._particleSprite.scale.set(0, 0),
            () => this._particleSprite.position.set(0, 0)
        ]);

        return tl;
    }

    private createTexts() {
        this._textContainer.scale.set(0, 0);
        this._winNumbersText = new PIXI.BitmapText(Currency.formatValue(0), TeslaTextStyles.COUNT_UP_TEXTSTYLE);
        this._winNumbersText.pivot.x = this._winNumbersText.textWidth * 0.5;
        this._winNumbersText.pivot.y = this._winNumbersText.textHeight * 0.5;
        this._textContainer.addChild(this._winNumbersText);
        this._container.addChild(this._textContainer);
    }

    private getTextAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._textContainer.position.set(0, 0);
        tl.add([
            () => this.updateWinNumbers(),
            new TweenLite(this._textContainer, 0.2, {alpha: 1,}),
            new TweenLite(this._textContainer.scale, 0.5, {x: 1, y: 1, ease: Expo.easeOut}),
            new TweenLite(this._textContainer.position, 3.5, {
                y: "-=80",
                ease: Linear.easeNone
            })
        ]);
        tl.add([
            new TweenLite(this._textContainer, 0.5, {alpha: 0, ease: Expo.easeOut})
        ], "-=1.5");
        tl.add([
            () => this._textContainer.scale.set(0, 0),
            () => this._textContainer.position.set(0, 0)
        ]);

        return tl;
    }

    private updateWinNumbers() {
        this._winNumbersText.text = Currency.formatValue(this._currentWin);
        this._winNumbersText.pivot.x = this._winNumbersText.textWidth * 0.5;
        this._winNumbersText.pivot.y = this._winNumbersText.textHeight * 0.5;

    }


    public getWinAmountDisplay(newWinAmount: number, winRatioConfig: IWinRatioConfig): TimelineLite {

        const tl: TimelineLite = new TimelineLite();

        this._currentWin = newWinAmount;

        if (winRatioConfig.ratio < 3) {
            this._particleSprite.texture = GameResources.getTextures(TeslaGameAssets.INITIAL_WIN_PARTICLES_SMALL)[0];
        } else if (winRatioConfig.ratio < 5) {
            this._particleSprite.texture = GameResources.getTextures(TeslaGameAssets.INITIAL_WIN_PARTICLES_MEDIUM)[0];
        } else {
            this._particleSprite.texture = GameResources.getTextures(TeslaGameAssets.INITIAL_WIN_PARTICLES_BIG)[0];
        }

        if (GameSetting.isFastSpin === true) {
            tl.timeScale(2);
        }


        tl.add([
            this.getParticleAnimation(),
            this.getTextAnimation()
        ]);

        return tl;

    }

    public displayIndividualLineAmount(linesWinsData: IBetLineWinData[]): void {
        const posArray: number[] = [];

        for (let i: number = 0; i < linesWinsData.length; i++) {
            let betLineWinData: IBetLineWinData = linesWinsData[i];
            let betLine = betLineWinData.betLine;

            const symId: number = betLine[betLineWinData.nrOfSymbols - 1];
            const basePosition: number[] = Helper.getSymbolPositions(betLineWinData.nrOfSymbols - 1, symId);
            const amountText: PIXI.BitmapText = new PIXI.BitmapText(Currency.formatValue(betLineWinData.multipliedAmount), TeslaTextStyles.INDIVIDUAL_AMOUNT_TEXTSTYLE);
            amountText.maxWidth = 100;
            let uniqueNo: number = parseInt(basePosition[0].toString() + basePosition[1].toString());

            if (!posArray.includes(uniqueNo)) {
                posArray.push(uniqueNo);
                const amountContainer: PIXI.Container = new PIXI.Container();
                amountContainer.name = uniqueNo.toString();
                amountText.position.set(basePosition[0], basePosition[1]);
                if (amountText.textWidth > amountText.maxWidth) {
                    amountText.scale.set(amountText.maxWidth / amountText.textWidth, 1);
                }
                amountText.pivot.x = amountText.textWidth * 0.5;
                amountText.pivot.y = amountText.textHeight * 0.5;
                amountContainer.addChild(amountText);
                amountContainer.alpha = 0;
                if (symId === 0) {
                    amountContainer.position.y -= 25;
                } else if (symId === 2) {
                    amountContainer.position.y += 25;
                }
                this._individualWinTextContainer.addChild(amountContainer);
            } else {
                let oldContainer: PIXI.Container = <PIXI.Container>this._individualWinTextContainer.getChildByName(uniqueNo.toString());
                oldContainer.addChild(amountText);
                oldContainer.children.forEach((item, index) => {
                    const displayAmount: PIXI.BitmapText = (<PIXI.BitmapText>item);

                    if (oldContainer.children.length > 3) {
                        displayAmount.scale.set(1 - 0.05 * oldContainer.children.length, 1 - 0.05 * oldContainer.children.length);

                    }

                    if (displayAmount.textWidth > amountText.maxWidth) {
                        displayAmount.scale.set(amountText.maxWidth / displayAmount.textWidth, amountText.maxWidth / displayAmount.textWidth);
                    }
                    displayAmount.position.set(basePosition[0], basePosition[1] + 60 - index * (displayAmount.height));
                    displayAmount.pivot.x = displayAmount.textWidth * 0.5;
                    displayAmount.pivot.y = displayAmount.textHeight * 0.5;
                });
            }

        }

        this._individualWinTextContainer.children.forEach((fontContainer) => {
            const oneSymContainer: PIXI.Container = <PIXI.Container>fontContainer;
            const oneTl: TimelineLite = new TimelineLite();
            oneTl.to(oneSymContainer, 0.05, {alpha: 1}, 0);
               oneTl.to(oneSymContainer.position, 0.9, {
                   y: "-=40",
                   ease: Linear.easeNone
               }, ">");
               oneTl.to(oneSymContainer, 0.05, {alpha: 0}, "<0.05");
        });
    }

    public individualLineAmountReset():void{
        if (this._individualWinTextContainer.children.length > 0) {
            this._individualWinTextContainer.children.forEach((item) => {
                (<PIXI.Container>item).children.forEach((font) => {
                    font.destroy();

                });
            });
            this._individualWinTextContainer.removeChildren();
        }
    }


}